/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { PutSavePrintExampleForConfigurationMutationRequest, PutSavePrintExampleForConfigurationMutationResponse, PutSavePrintExampleForConfigurationPathParams, PutSavePrintExampleForConfiguration400 } from "../../models/PutSavePrintExampleForConfiguration";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getPutSavePrintExampleForConfigurationUrl({ uuid }: { uuid: PutSavePrintExampleForConfigurationPathParams["uuid"] }) {
  const res = { method: 'PUT', url: `/api/v1/configurations/${uuid}/print-example` as const }  
  return res
}

/**
 * {@link /api/v1/configurations/:uuid/print-example}
 */
export async function putSavePrintExampleForConfiguration({ uuid, data }: { uuid: PutSavePrintExampleForConfigurationPathParams["uuid"]; data: PutSavePrintExampleForConfigurationMutationRequest }, config: Partial<RequestConfig<PutSavePrintExampleForConfigurationMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PutSavePrintExampleForConfigurationMutationResponse, ResponseErrorConfig<PutSavePrintExampleForConfiguration400>, PutSavePrintExampleForConfigurationMutationRequest>({ method : "PUT", url : getPutSavePrintExampleForConfigurationUrl({ uuid }).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}